import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { Transaction } from '../types'
import { computed, Ref, ref } from 'vue'

///////////////////////////////////////////////////////////////////////////////
// Utils
///////////////////////////////////////////////////////////////////////////////

const addItem = (items: Ref<Map<string, unknown>>, item: any) => {
  if (!item.cid) {
    items.value.set(item.id, item)
    return
  }

  items.value.set(item.cid, item)
}

const addItems = (items: Ref<Map<string, unknown>>, newItems: any[]) => {
  for (const item of newItems) {
    addItem(items, item)
  }
}

const clearItems = (items: Ref<Map<string, unknown>>) => {
  items.value = new Map()
}

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

type TransactionMap = Map<string, Transaction>
export const useTransactionStore = defineStore('investing/transactionStore', () => {
  const items = ref<TransactionMap>(new Map())
  const transactions = computed(() => Array.from(items.value.keys()).map((key) => items.value.get(key)))

  const fetchTransactions = async (
    investor_set_id: string,
    { slug, shareholder_cids, dateRange }: { slug: string; shareholder_cids?: string[]; dateRange?: string[] },
  ) => {
    const params = new URLSearchParams()
    params.set('investor_set_id', investor_set_id)
    if (shareholder_cids) params.set('shareholder_cids', shareholder_cids.join(','))
    if (dateRange) params.set('date_range', dateRange.join(','))
    const queryParams = params.toString() ? `?${params}` : ''

    const data = await useFetch(`/v4/${slug}/investing/transactions${queryParams}`).get<Transaction[]>()
    clearItems(items)
    addItems(items, data)
  }

  const removeTransaction = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/transactions/${id}/remove`).post()
  }

  return {
    items,
    transactions,

    fetchTransactions,
    removeTransaction,
  }
})
